import { FunctionComponent } from 'react';
import StarIcon from '@mui/icons-material/Star';
import styles from './ReviewSummary.module.css';

interface ReviewSummaryProps {
  rating: number;
  reviewCount: number;
  distribution?: {
    5: number;
    4: number;
    3: number;
    2: number;
    1: number;
  };
}

const ReviewSummary: FunctionComponent<ReviewSummaryProps> = ({
  rating,
  reviewCount,
  distribution
}) => {
  return (
    <div className={styles.reviewsSummary}>
      <div className={styles.overallRating}>
        <span className={styles.ratingNumber}>{rating.toFixed(1)}</span>
        <div className={styles.ratingStars}>
          {[1, 2, 3, 4, 5].map((star) => (
            <StarIcon 
              key={star} 
              className={star <= Math.round(rating) ? styles.starFilled : styles.starEmpty}
            />
          ))}
        </div>
        <span className={styles.reviewCountText}>Based on {reviewCount} reviews</span>
      </div>
      
      {distribution && (
        <div className={styles.distribution}>
          {[5, 4, 3, 2, 1].map((stars) => {
            const count = distribution[stars as keyof typeof distribution];
            const percentage = (count / reviewCount) * 100;
            
            return (
              <div key={stars} className={styles.distributionRow}>
                <span className={styles.distributionLabel}>{stars}</span>
                <StarIcon className={styles.distributionStar} />
                <div className={styles.distributionBar}>
                  <div 
                    className={styles.distributionFill} 
                    style={{ width: `${percentage}%` }}
                  />
                </div>
                <span className={styles.distributionCount}>{count}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ReviewSummary;